import React from 'react';
import { useTranslation } from 'next-i18next';

import { OntarioColumn } from '~/theme';

import {
    FooterContainer,
    FooterRow,
    ExpandedFooterBottomBlock,
    FooterLinksContainer,
    FooterLink,
    FooterCopyrightLink,
} from './styles';

interface FooterProps {
    role: string;
}

interface Link {
    name: string;
    url: string;
}

const Footer = ({ role }: FooterProps) => {
    const { t } = useTranslation('base-layout');
    const links: Link[] = [...(t('footer.links', { returnObjects: true }) as [])] as [];

    const currentDate = new Date().getFullYear().toString();

    return (
        <FooterContainer role={role}>
            {/* <ExpandedFooterTopBlock>
                <FooterRow>
                    <OntarioColumn>
                        <Heading2 styledAs="h4">
                            {t('base-layout:footer.ministryBlock.heading')}
                        </Heading2>
                        <TextParagraph>
                            {t('base-layout:footer.ministryBlock.description')}
                        </TextParagraph>
                    </OntarioColumn>
                    <OntarioColumn>
                        <Heading2 styledAs="h4">
                            {t('base-layout:footer.contactUsBlock.heading')}
                        </Heading2>
                        <TextParagraph>
                            {t('base-layout:footer.contactUsBlock.callServiceOntario')}{' '}
                            <a href="tel:+18002678097">
                                {t('base-layout:footer.contactUsBlock.number')}
                            </a>{' '}
                            <span
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: t('base-layout:footer.contactUsBlock.daysAndTime'),
                                }}
                            />
                        </TextParagraph>
                        <FooterSocialMediaLinksContainer>
                            <li>
                                <FooterSocialMediaLink
                                    href="https://www.facebook.com/ServiceOntario"
                                    aria-label="Facebook"
                                >
                                    {icons.facebookSVG}
                                </FooterSocialMediaLink>
                            </li>
                            <li>
                                <FooterSocialMediaLink
                                    href="https://twitter.com/ServiceOntario"
                                    aria-label="Twitter"
                                >
                                    {icons.twitterSVG}
                                </FooterSocialMediaLink>
                            </li>
                        </FooterSocialMediaLinksContainer>
                    </OntarioColumn>
                </FooterRow>
            </ExpandedFooterTopBlock> */}
            <ExpandedFooterBottomBlock>
                <FooterRow>
                    <OntarioColumn>
                        <FooterLinksContainer>
                            {links &&
                                links.map((link, index) => (
                                    <li key={index}>
                                        <FooterLink href={link.url} target="_blank">
                                            {link.name}
                                        </FooterLink>
                                    </li>
                                ))}
                        </FooterLinksContainer>
                        <FooterCopyrightLink
                            href={t('base-layout:footer.kingsPrinter.url') ?? ''}
                            target="_blank"
                        >
                            {`${t('base-layout:footer.kingsPrinter.name')}`}
                            {currentDate}
                        </FooterCopyrightLink>
                    </OntarioColumn>
                </FooterRow>
            </ExpandedFooterBottomBlock>
        </FooterContainer>
    );
};

export default Footer;
